import {ChangeDetectorRef, Component} from "@angular/core";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {PreparationResourceTypeEntityModel} from "../preparation-resource-type-entity.model";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-preparation-resource-type-edit-page",
    templateUrl: "./preparation-resource-type-edit-page.component.html",
    providers: [(provideEntityModel(PreparationResourceTypeEntityModel))]
})
export class PreparationResourceTypeEditPageComponent extends AbstractEditPage {
    constructor(public model: PreparationResourceTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
